import AdminPropertyReviewTable from './AdminPropertyReviewTable';

const ApprovedProperties = () => (
  <AdminPropertyReviewTable
    filterStatus="approved"
    title="العقارات الموافق عليها"
    subtitle="إدارة العقارات المنشورة الموافق عليها ورفضها أو إعادتها للمراجعة"
  />
);

export default ApprovedProperties;
